import * as React from "react";
import classnames from "classnames";
import { theme } from "../../theme/theme";
import { Document } from "../../types/Document";
import {
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Collapse,
    Card,
    CardHeader
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { reduce, sortBy } from "lodash";

import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

import DocumentIcon from "../Icons/DocumentIcon";
import { styles } from "./Tools.style";

interface ToolsProps {
    list: {
        adhesion?: Document[],
        common?: Document[],
        proposition?: Document[]
    };
}

interface ToolsState {
    expanded: boolean;
}

class Tools extends React.Component<ToolsProps & WithStyles<typeof styles>, ToolsState> {

    state = {
        expanded: false
    };

    public handleExpandClick () {
        this.setState(state => ({expanded: !state.expanded}));
    }

    public handleDocumentClick (doc) {
        const link = document.createElement("a");
        link.download = doc.label;
        link.href = doc.url;
        link.click();
    }

    public render() {

        const {classes, list} = this.props;
        const {expanded} = this.state;
        let documents = reduce(list, (sum: Document[], docs: Document[]) => {
            return sum.concat(docs);
        }, []);
        documents = sortBy(documents, (d) => d.label);

        return (
            <Card className={classes.card} elevation={0} square={true}>
                <CardHeader className={classes.header} title="Documents annexes"/>
                <Collapse in={expanded} collapsedHeight="152px">
                    <List component="nav">
                        {documents.map((doc, index) => (
                            <ListItem button={true} key={index} onClick={() => this.handleDocumentClick(doc)}>
                                <ListItemIcon><DocumentIcon nativeColor={theme.palette.primary.main}/></ListItemIcon>
                                <ListItemText primary={<Typography>{doc.label}</Typography>}/>
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
                <Button
                    className={classnames(classes.expand, {
                        [classes.expandOpen]: this.state.expanded
                    })}
                    onClick={() => this.handleExpandClick()}
                    aria-expanded={this.state.expanded}
                    aria-label="Voir plus"
                    size="small"
                >
                    <Typography variant="body2">voir plus</Typography>
                    <ExpandMoreIcon/>
                </Button>
            </Card>
        );
    }

}

export default withStyles(styles)(Tools);


// WEBPACK FOOTER //
// ./src/components/Tools/Tools.tsx